import { numberFormat } from "../../../config/numberFormat";

export default function SaleOutstandingBar({ title, total, values, labels, colors }) {
  const percent = (val) => (val / total) * 100;

  if (total === 0) {
    return (
      <div style={styles.card}>
        <h3 style={styles.header}>{title}</h3>
        <p style={{ color: "#999", fontStyle: "italic" }}>No data available</p>
      </div>
    );
  }
  return (
    <div style={{ ...styles.card}}>
      <h3 style={styles.header}>{title}</h3>
      <p>Total Receivables: {numberFormat(total)}</p>
      <div style={styles.bar}>
        {values.map((val, i) => (
          <div
            key={i}
            style={{ ...styles["bar-segment"], width: `${percent(val)}%`, backgroundColor: colors[i] }}
          >
            
          </div>
        ))}
      </div>
      <div style={styles.legend}>
        {labels.map((label, i) => (
          <div key={i} style={styles["legend-item"]}>
            <span style={{...styles["legend-item span"], backgroundColor: colors[i] }}></span> <p style={{color: colors[i]}}>{label}: {numberFormat(values[i])}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

const styles = {
  card: {
     padding: "20px",
    borderRadius: "10px",
    backgroundColor: "#fff",
    boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
    maxWidth: "600px",
    fontFamily: "sans-serif"
  },
  header: {
    marginBottom: 16,
    fontSize: 18,
    fontWeight: 600,
    color: "#333"
  },
  bar: {
    display: "flex",
    height: "30px",
    borderRadius: "5px",
    overflow: "hidden",
  },
  "bar-segment": {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "14px",
    fontWeight: "bold",
  },
  legend: {
    marginTop: "10px",
    display: "flex",
    flexDirection: "column",
  },
  "legend-item": {
    display: "flex",
    alignItems: "center",
    marginBottom: "5px",
  },
  "legend-item span": {
    width: "15px",
    height: "15px",
    borderRadius: "50%",
    marginRight: "10px",
  },
  "legend-item label": {
    fontSize: "14px",
    color: "#444",
  },
  "legend-item value": {
    fontWeight: "bold",
    fontSize: "14px",
    marginLeft: "10px",
  },
};
